module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "financial-analytics"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-4 p-3 bg-white rounded shadow-sm border"
  }, [_c('div', [_c('h2', {
    staticClass: "mb-1 text-primary font-weight-bold h5"
  }, [_vm._v("Financial Analytics")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-nav', {
    staticClass: "revenue-sub-nav",
    attrs: {
      "pills": ""
    }
  }, [_c('b-nav-item', {
    staticClass: "mode-toggle mr-3",
    attrs: {
      "active": true
    }
  }, [_c('b-button-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": _vm.activeMode === 'revenue' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function($event) {
        _vm.activeMode = 'revenue'
      }
    }
  }, [_vm._v("REVENUE")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": _vm.activeMode === 'expense' ? 'danger' : 'outline-danger'
    },
    on: {
      "click": function($event) {
        _vm.activeMode = 'expense'
      }
    }
  }, [_vm._v("EXPENSE")])], 1)], 1), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "active": _vm.activeDim === 'summary'
    },
    on: {
      "click": function($event) {
        _vm.activeDim = 'summary'
      }
    }
  }, [_vm._v("Summary")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "active": _vm.activeDim === 'client'
    },
    on: {
      "click": function($event) {
        _vm.activeDim = 'client'
      }
    }
  }, [_vm._v("Clients")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "active": _vm.activeDim === 'vehicle'
    },
    on: {
      "click": function($event) {
        _vm.activeDim = 'vehicle'
      }
    }
  }, [_vm._v("Vehicles")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "active": _vm.activeDim === 'shippingLine'
    },
    on: {
      "click": function($event) {
        _vm.activeDim = 'shippingLine'
      }
    }
  }, [_vm._v("Shipping Lines")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "active": _vm.activeDim === 'month'
    },
    on: {
      "click": function($event) {
        _vm.activeDim = 'month'
      }
    }
  }, [_vm._v("Monthly")]), _vm._v(" "), _c('b-nav-item', {
    attrs: {
      "active": _vm.activeDim === 'year'
    },
    on: {
      "click": function($event) {
        _vm.activeDim = 'year'
      }
    }
  }, [_vm._v("Yearly")])], 1)], 1)]), _vm._v(" "), (_vm.activeDim !== 'summary') ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-button-group', {
    staticClass: "mr-3 shadow-sm",
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": _vm.viewMode === 'table' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function($event) {
        _vm.viewMode = 'table'
      }
    }
  }, [_c('md-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "16"
    }
  }, [_vm._v("table_chart")]), _vm._v(" TABLE\n        ")], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": _vm.viewMode === 'graph' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function($event) {
        _vm.viewMode = 'graph'
      }
    }
  }, [_c('md-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "16"
    }
  }, [_vm._v("bar_chart")]), _vm._v(" BAR\n        ")], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": _vm.viewMode === 'timeline' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function($event) {
        _vm.viewMode = 'timeline'
      }
    }
  }, [_c('md-icon', {
    staticClass: "mr-1",
    attrs: {
      "size": "16"
    }
  }, [_vm._v("show_chart")]), _vm._v(" TIMELINE\n        ")], 1)], 1), _vm._v(" "), (_vm.viewMode === 'table') ? _c('b-form-input', {
    staticClass: "shadow-sm",
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": "Search...",
      "size": "sm"
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (_vm.activeDim === 'summary') ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('b-card', {
    staticClass: "mb-4 border-0 h-100",
    attrs: {
      "shadow-sm": ""
    }
  }, [_c('h6', {
    staticClass: "font-weight-bold text-dark mb-3"
  }, [_vm._v(_vm._s(_vm.activeMode === 'revenue' ? 'Revenue' : 'Expense') + " by Client")]), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "280",
      "options": _vm.currentDonutOptions.client.options,
      "series": _vm.currentDonutOptions.client.series
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('b-card', {
    staticClass: "mb-4 border-0 h-100",
    attrs: {
      "shadow-sm": ""
    }
  }, [_c('h6', {
    staticClass: "font-weight-bold text-dark mb-3"
  }, [_vm._v(_vm._s(_vm.activeMode === 'revenue' ? 'Revenue' : 'Expense') + " by Vehicle")]), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "280",
      "options": _vm.currentDonutOptions.vehicle.options,
      "series": _vm.currentDonutOptions.vehicle.series
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "4"
    }
  }, [_c('b-card', {
    staticClass: "mb-4 border-0 h-100",
    attrs: {
      "shadow-sm": ""
    }
  }, [_c('h6', {
    staticClass: "font-weight-bold text-dark mb-3"
  }, [_vm._v(_vm._s(_vm.activeMode === 'revenue' ? 'Revenue' : 'Expense') + " by Shipping Line")]), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": "donut",
      "height": "280",
      "options": _vm.currentDonutOptions.shippingLine.options,
      "series": _vm.currentDonutOptions.shippingLine.series
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('b-card', {
    staticClass: "border-0 text-center py-4",
    attrs: {
      "shadow-sm": ""
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-around"
  }, _vm._l((_vm.summaryStats), function(stat, idx) {
    return _c('div', {
      key: idx
    }, [_c('div', {
      staticClass: "text-muted small text-uppercase font-weight-bold mb-1"
    }, [_vm._v(_vm._s(stat.label))]), _vm._v(" "), _c('h3', {
      staticClass: "font-weight-bold mb-0",
      class: stat.color
    }, [_vm._v(_vm._s(stat.value))])])
  }))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeDim !== 'summary') ? _c('b-card', {
    staticClass: "border-0 shadow-sm overflow-hidden",
    attrs: {
      "no-body": ""
    }
  }, [(_vm.viewMode === 'table') ? _c('div', {
    staticClass: "p-0"
  }, [_c('b-table', {
    staticClass: "mb-0 financial-table",
    attrs: {
      "items": _vm.currentRawData,
      "fields": _vm.tableFields,
      "filter": _vm.filter,
      "hover": "",
      "striped": "",
      "responsive": "",
      "show-empty": ""
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function(data) {
        return [_vm._v("\n          " + _vm._s(data.index + 1) + "\n        ")]
      }
    }, {
      key: "value",
      fn: function(data) {
        return [_c('span', {
          staticClass: "font-weight-bold",
          class: _vm.activeMode === 'revenue' ? 'text-success' : 'text-danger'
        }, [_vm._v(_vm._s(_vm.formatCurrency(data.value)))])]
      }
    }, {
      key: "pendingFine",
      fn: function(data) {
        return [_c('span', {
          staticClass: "text-warning font-weight-bold"
        }, [_vm._v(_vm._s(_vm.formatCurrency(data.value)))])]
      }
    }, {
      key: "disposedFine",
      fn: function(data) {
        return [_c('span', {
          staticClass: "text-muted"
        }, [_vm._v(_vm._s(_vm.formatCurrency(data.value)))])]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [_c('div', {
    staticClass: "text-center p-4 text-muted"
  }, [_vm._v("No data found for this period")])])], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.viewMode === 'graph' || _vm.viewMode === 'timeline') ? _c('div', {
    staticClass: "p-4 bg-white position-relative"
  }, [(!_vm.currentRawData || !_vm.currentRawData.length) ? _c('div', {
    staticClass: "text-center py-5"
  }, [_c('md-icon', {
    staticClass: "text-light mb-3",
    attrs: {
      "size": "48"
    }
  }, [_vm._v("analytics")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("No analytics data available for this dimension")])], 1) : _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-4"
  }, [_c('h6', {
    staticClass: "font-weight-bold text-muted uppercase"
  }, [_vm._v(_vm._s(_vm.activeMode === 'revenue' ? 'Revenue' : 'Expense') + " Contribution: " + _vm._s(_vm.dimensionLabel))]), _vm._v(" "), (_vm.chartData && _vm.chartData.series && _vm.chartData.series[0]) ? _c('span', {
    staticClass: "small text-muted"
  }, [_vm._v("\n             Showing Top " + _vm._s(_vm.chartData.series[0].data ? _vm.chartData.series[0].data.length : 0) + "\n           ")]) : _vm._e()]), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": _vm.viewMode === 'timeline' ? 'area' : 'bar',
      "height": "450",
      "options": _vm.chartData.options,
      "series": _vm.chartData.series
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.activeDim !== 'summary') ? _c('b-row', {
    staticClass: "mt-4"
  }, _vm._l((_vm.dimensionStats), function(stat, idx) {
    return _c('b-col', {
      key: idx,
      attrs: {
        "lg": "4"
      }
    }, [_c('b-card', {
      staticClass: "border-0 shadow-sm text-center position-relative overflow-hidden"
    }, [(_vm.loading) ? _c('div', {
      staticClass: "loading-overlay"
    }, [_c('b-spinner', {
      attrs: {
        "small": "",
        "variant": "primary"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      class: {
        'loading-blur': _vm.loading
      }
    }, [_c('div', {
      staticClass: "small text-muted mb-1 text-uppercase font-weight-bold"
    }, [_vm._v(_vm._s(stat.label))]), _vm._v(" "), _c('h4', {
      staticClass: "mb-0 font-weight-bold",
      class: stat.colorClass
    }, [_vm._v(_vm._s(stat.value))])])])], 1)
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bd6bf73","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/FinancialAnalyticsTab.vue
// module id = 2426
// module chunks = 0